const convertOrderItemsToCartItems = (orderItems) => {
  const orderItemsWithoutComboItems =
    orderItems.filter(item => !item.comboSet)

  return orderItemsWithoutComboItems.map(orderItem => {
    const specificationItems = []

    orderItem.orderItemSpecifications.forEach(orderItemSpecification =>
      orderItemSpecification.specificationItems.forEach(specificationItem =>
        specificationItems.push({
          ...specificationItem,
          specificationId: orderItemSpecification._id,
          maxFreeQuantity: orderItemSpecification.maxFreeQuantity,
          _id: specificationItem.specificationItemId
        })
      )
    )

    return {
      orderItemId: orderItem._id,
      code: orderItem.foodCode,
      foodName: orderItem.foodName,
      foodImageCover: orderItem.foodImageCover,
      isSimple: orderItem.isSimple,
      taxInclusive: orderItem.taxInclusive,
      specificationItems,
      optionName: orderItem.option.name,
      foodId: orderItem.foodId,
      categoryIds: orderItem.categoryIds,
      optionId: orderItem.option._id,
      quantity: orderItem.quantity,
      salePrice: orderItem.salePrice,
      taxItems: orderItem.taxItems,
      unit: orderItem.unit,
      systemDiscount:
        (orderItem.systemDiscount || 0) / orderItem.quantity
    }
  })
}

export default convertOrderItemsToCartItems